import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { LoginProvider } from './module/ContextAPI';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import ScrollToTop from './module/ScrollToTop';

// MUI 전체 테마
const theme = createTheme({
  palette: {
    primary: {
      main: '#24408E',
    },
    secondary: {
      main: '#10263B',
    },
    cancel: {
      main: '#999999',
    },
    red: {
      main: '#C21807',
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      custom: 440,
      sm: 640,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
  typography: {
    body1: {
      color: '#333333',
    },
    body2: {
      color: '#333333',
    },
    h5: {
      color: '#333333',
    },
    h4: {
      color: '#333333',
    },
    h3: {
      color: '#333333',
    },
    fontFamily: [
      'Pretendard',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'system-ui',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
  },
  components: {
    MuiButton: {
      defaultProps: {
        variant: 'contained',
        disableElevation: true,
        style: { fontWeight: 600, maxWidth: '400px', padding: 2 },
      },
    },
    MuiTextField: {
      defaultProps: {
        inputProps: {
          style: { padding: '7px 0px 7px 13px', backgroundColor: '#FFFFFF' },
        },
      },
    },
    MuiContainer: {
      defaultProps: {
        disableGutters: true,
      },
    },
    MuiTableCell: {
      defaultProps: {
        align: 'center',
      },
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <LoginProvider>
          <ScrollToTop />
          <App />
        </LoginProvider>
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
